import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { tap, catchError, Observable, take } from 'rxjs';
import { LoggerService } from './utils/logger.service';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'any'
})
export class UserSettingsService {

    constructor(
        private loggerService: LoggerService,
        private _http: HttpClient
    ) { }

    public loadUserSettings$(category: string): Observable<any> {
        return this._http.get<any>(`${environment.apiEndpoint}/users/settings/${category}`).pipe(
            take(1),
            tap((val: any) => {
                this.loggerService.info('User settings loaded', val);
            }),
            catchError(err => {
                this.loggerService.error(`Error on .../users/settings/${category}`)
                throw 'error in source. Details: ' + err;
            })
        );
    }

    public saveUserSettings$(category: string, payload: any): Observable<any> {
        return this._http.put<any>(`${environment.apiEndpoint}/users/settings/${category}`, payload).pipe(
            take(1),
            tap((val: any) => {
                this.loggerService.info('User settings saved', val);
            }),
            catchError(err => {
                this.loggerService.error(`Error on .../users/settings/${category}`)
                throw 'error in source. Details: ' + err;
            })
        );
    }
}
